import { t } from 'components/translation/Translation';

export const contactOptions = [
  {
    display: t('onboarding:onboarding.email'),
    id: 'email',
    name: 'contact',
    value: 'email',
  },
  {
    display: t('onboarding:onboarding.phone'),
    id: 'phoneNumber',
    name: 'contact',
    value: 'phone',
  },
  {
    display: t('onboarding:onboarding.either'),
    id: 'either',
    name: 'contact',
    value: 'either',
  },
];
